<template>
  <div class="project-info">
    <header class="topic-title">项目信息</header>
    <main>
      <info-row label="项目名称">{{ projectInfo.name }}</info-row>
      <info-row label="项目周期">
        {{ projectInfo.startPeriod }} 至 {{ projectInfo.endPeriod }}
      </info-row>
      <info-row label="项目简介">
        {{ projectInfo.description }}
      </info-row>
      <!-- <info-row label="项目群">
        <el-avatar :size="32" :src="group.avatarUrl" class="avatar">
          {{ group.name ? group.name.slice(0, 2).toUpperCase() : "无" }}
        </el-avatar>
        {{ group.name }}
      </info-row> -->
    </main>
  </div>
</template>

<script>
import InfoRow from "./components/InfoRow"

export default {
  name: "project-info",
  components: { InfoRow },
  props: {
    projectInfo: Object
  },
  data() {
    return {
      group: {
        avatarUrl: "",
        name: "9号项目钉钉群 (5人)"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-info {
  ::v-deep .info-row {
    .content {
      display: flex;
      align-items: center;
    }
  }
  .avatar {
    background-color: $color-auxiliary;
    margin-right: 10px;
  }
}
</style>
